import React from "react"
import SvgSprite from "../SvgSprite"


function Image({src, marks = [], className = ''}){
    let classes = ''
    if(className){
        classes += ` ${className}`
    }
    if(!src){
        classes += ` -undefined`
    }
    return (
        <div className={`image ${classes}`}>
            <img src={src} alt="" />
            <div class="image-undefined">
                <SvgSprite id="image_undefined" section="defaults"/>
            </div>
            <div class="image__marks">
                {marks.map((mark) => {
                    // console.log('mark', mark)
                    return (
                        <div class={`image__mark -${mark}`}>
                            <SvgSprite id={mark}/>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default Image